// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2R68b","itemTitle":"ClientEmergencyInfo_itemTitle__3v_Uz","itemText":"ClientEmergencyInfo_itemText__D4GNA"};